import DashboardLayout from "../layouts/DashboardLayout";
// import OrderList from '../pages/order/OrderList'
// import OrderDetail from '../pages/order/OrderDetail'
// import OrderListMobile from '../pages/order/OrderListMobile'
// import OrderCreateContact from '../pages/order/OrderCreateContact'
// import OrderAccountList from '../pages/order/OrderAccountList'
// import OrderAccountListMobile from "@/pages/order/OrderAccountListMobile";

export const managementMenu = {
  path: "/management",
  component: DashboardLayout,
  name: "IndexManagement",
  redirect: "/management/orders",
  children: [
    {
      path: "orders",
      name: "OrderManagement",
      component: () => import("@/pages/order-management/List.vue"),
      meta: {
        roles: "all",
        requiresAuth: true,
        breadcrumb: [
          {
            title: "Danh sách đơn hàng",
          },
        ],
      },
    },
    {
      path: "create-order",
      name: "CreateOrder",
      component: () => import("@/pages/order-management/createOrder.vue"),
      meta: {
        roles: ['oms-order_create'],
        requiresAuth: true,
        breadcrumb: [
          {
            title: "TẠO ĐƠN HÀNG",
          },
        ],
      },
    },
    {
      path: "detail-order/:orderId",
      name: "DetailOrder",
      component: () => import("@/pages/order-management/detailOrder.vue"),
      meta: {
        roles: "all",
        requiresAuth: true,
        breadcrumb: [
          {
            title: "CHI TIẾT ĐƠN HÀNG",
          },
        ],
      },
    },
  ],
};
